/**
 * Created by andrey on 18.12.2025
 */

const MSIX = function () {
    Microsoft.call(this, connector.MSIX);
};

MSIX.prototype = Object.create(Microsoft.prototype);
MSIX.prototype.constructor = MSIX;

MSIX.prototype.getLocalStoragePrefix = function () {
    return "_msix";
};

MSIX.prototype.getAccessToken = function () {
    return "msix";
};

MSIX.prototype.canReview = function () {
    return false;
};

MSIX.prototype.isLatestVersionCheckSupported = function () {
    return false;
};

MSIX.prototype._requestReview = function (callback) {
    callback(connector.CODE_FAILED);
};

MSIX.prototype._parsePayload = function (callback) {
    callback({ channel: "landing" });
};

MSIX.prototype._initialize = function (callback) {
    document.addEventListener("keydown", (e) => {
        const key = e.key || "";
        if (key === "Enter" && e.altKey && !e.repeat) {
            this.toggleFullScreen();
        }
    }, false);

    Microsoft.prototype._initialize.call(this, callback);
};

MSIX.prototype.isFullscreenAvailable = function () {
    return true;
};

MSIX.prototype.toggleFullScreen = function () {
    this.callNative("app.toggleFullScreen");
};

// inherits Microsoft, but no game has a cross-promo link for this source
MSIX.prototype.canSwitchGame = function () {
    return false;
};
